var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDriverNotSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.438 1.001c.186.08.388.065.582.099.506.083.996.249 1.451.49a.455.455 0 0 1 .334.238c1.042.911 1.244 2.165 1.365 3.494-.6-.348-1.222-.528-1.862-.652-1.51-.293-3.035-.34-4.565-.258-.97.052-1.934.168-2.874.437a4.53 4.53 0 0 0-1.08.457c.123-1.326.348-2.568 1.387-3.474.146-.188.35-.319.579-.37a5.498 5.498 0 0 1 1.708-.425c.014 0 .027-.025.041-.037h.123c.025.028.059.02.09.02h.146c.031 0 .065.008.09-.02h2.204c.022.025.053.02.081.02.029.002.06.005.082-.02L8.438 1z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.866 7.865c.102.314.24.605.479.837.391.383.778.435 1.235.14.504-.325.994-.684 1.572-.866 1.104-.35 2.215-.391 3.332-.074.446.125.824.386 1.193.662.281.209.576.387.93.45.407.071.753-.04 1.038-.342a1.93 1.93 0 0 0 .508-1.137.661.661 0 0 1 .016-.079c0-.005.009-.009.018-.017.075.034.043.106.044.159.052 2.614-1.84 4.928-4.356 5.332-2.742.441-5.27-1.263-5.937-4.004a3.129 3.129 0 0 1-.111-.72c-.002-.116-.069-.24.039-.34z",
    fill: "#D5D5D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.247 5.047c1.07.007 2.402.096 3.7.472.327.095.645.216.93.411.228.157.342.362.317.653-.033.364-.104.715-.277 1.038-.376.708-1.008.926-1.724.598a2.256 2.256 0 0 1-.504-.315c-.955-.795-2.07-.942-3.247-.859a4.937 4.937 0 0 0-2.64.985c-.067.049-.137.091-.205.135-.482.303-.887.257-1.281-.161-.445-.473-.564-1.068-.554-1.696.004-.196.176-.306.327-.403.413-.269.878-.4 1.346-.509 1.165-.269 2.349-.35 3.812-.35z",
    fill: "#979797"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.281,
    y: 0.134,
    width: 2.5,
    height: 16.362,
    rx: 1.25,
    transform: "rotate(45 12.281 .134)",
    fill: "#D9D9D9",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriverNotSelected);
export default __webpack_public_path__ + "static/media/ic-driver-not-selected.30b6b6a99b5331745917d5bf1966d451.svg";
export { ForwardRef as ReactComponent };